// frontend/src/utils/wake-backend.ts
// Quietly pings the backend (cold start mitigation). Returns true when it responds OK.

const DEFAULT_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ??
  "http://localhost:8000"; // dev fallback only (no legacy prod URL)

function normalizeBaseUrl(base: string): string {
  return base.replace(/\/+$/, "");
}

export async function wakeBackend(base = DEFAULT_BASE_URL): Promise<boolean> {
  const b = normalizeBaseUrl(base);

  // Try a few common health endpoints to stay robust across environments.
  const candidates = [
    `${b}/`,           // your new prod backend currently responds here
    `${b}/health`,
    `${b}/api/health`, // legacy-compatible if still present on some env
  ];

  for (const delay of [0, 2000, 4000, 8000, 12000]) {
    if (delay) await new Promise((r) => setTimeout(r, delay));

    for (const url of candidates) {
      try {
        const res = await fetch(url, { method: "GET", cache: "no-store" });
        if (res.ok) return true;
      } catch {
        // ignore network errors during cold start and keep trying
      }
    }
  }
  return false;
}